<div class="drr-theme">
  <router-outlet></router-outlet>
  <app-splashscreen
    [hidden]="(isSplashscreenHidden$ | async)"
    [step]="(step$ | async)"
  >
  </app-splashscreen>
  <app-dialog-invoker></app-dialog-invoker>
</div>
